/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SocialDrawerFeature } from './SocialDrawerFeature';
import {
    SocialDrawerFeatureFromJSON,
    SocialDrawerFeatureFromJSONTyped,
    SocialDrawerFeatureToJSON,
    SocialDrawerFeatureToJSONTyped,
} from './SocialDrawerFeature';

/**
 * 
 * @export
 * @interface SocialDrawerVisibilityResponse
 */
export interface SocialDrawerVisibilityResponse {
    /**
     * 
     * @type {string}
     * @memberof SocialDrawerVisibilityResponse
     */
    id?: string;
    /**
     * 
     * @type {SocialDrawerFeature}
     * @memberof SocialDrawerVisibilityResponse
     */
    feature?: SocialDrawerFeature;
    /**
     * Whether this feature is visible in the Social Drawer
     * @type {boolean}
     * @memberof SocialDrawerVisibilityResponse
     */
    isEnabled?: boolean;
    /**
     * Message shown when feature is disabled
     * @type {string}
     * @memberof SocialDrawerVisibilityResponse
     */
    disabledMessage?: string;
    /**
     * Order in which to display this feature
     * @type {number}
     * @memberof SocialDrawerVisibilityResponse
     */
    displayOrder?: number;
    /**
     * Human-readable label for this feature
     * @type {string}
     * @memberof SocialDrawerVisibilityResponse
     */
    displayLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof SocialDrawerVisibilityResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof SocialDrawerVisibilityResponse
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the SocialDrawerVisibilityResponse interface.
 */
export function instanceOfSocialDrawerVisibilityResponse(value: object): value is SocialDrawerVisibilityResponse {
    return true;
}

export function SocialDrawerVisibilityResponseFromJSON(json: any): SocialDrawerVisibilityResponse {
    return SocialDrawerVisibilityResponseFromJSONTyped(json, false);
}

export function SocialDrawerVisibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialDrawerVisibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'feature': json['feature'] == null ? undefined : SocialDrawerFeatureFromJSON(json['feature']),
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'disabledMessage': json['disabledMessage'] == null ? undefined : json['disabledMessage'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'displayLabel': json['displayLabel'] == null ? undefined : json['displayLabel'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function SocialDrawerVisibilityResponseToJSON(json: any): SocialDrawerVisibilityResponse {
    return SocialDrawerVisibilityResponseToJSONTyped(json, false);
}

export function SocialDrawerVisibilityResponseToJSONTyped(value?: SocialDrawerVisibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'feature': SocialDrawerFeatureToJSON(value['feature']),
        'isEnabled': value['isEnabled'],
        'disabledMessage': value['disabledMessage'],
        'displayOrder': value['displayOrder'],
        'displayLabel': value['displayLabel'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

